import { AdvancedType } from "src/modules/utils/shared/advanced-type";
import { Type } from "class-transformer";
import { EnaioCall } from "./EnaioCall";
import { EnaioUser } from "./EnaioUser";
import { StringMatcher } from "./StringMatcher";

export class EnaioCallGetUserList extends EnaioCall <EnaioUser[]> {
    @Type(() => StringMatcher)
    userNames: StringMatcher;
    detailed = false;
    returnGroups = false;
    returnWfUser = false;
    returnWfUserAttributes = false;
    returnWfUserParents = false;
    returnSubstitutes = false;
    substitutesEmptyIfNotAbsent = false;
    onlyActive = false;
    onlyWithWfUser = false;
    onlyGroups: string[];
    getModelType(): AdvancedType {
        return AdvancedType.ofClass(EnaioUser, 1);
    }

}
